'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SentEmailPopup = function () {
    function SentEmailPopup($ionicPopup, $filter, $rootScope) {
        _classCallCheck(this, SentEmailPopup);

        this.$ionicPopup = $ionicPopup;
        this.$translate = $filter('translate');
        this.$rootScope = $rootScope;
    }

    _createClass(SentEmailPopup, [{
        key: 'show',
        value: function show(username, sentEmail) {
            var confirmPopup = this.$ionicPopup.confirm({
                title: this.$translate('EXPORT_TO_EMAIL'),
                template: this.$rootScope.isIosApp ? '<span>' + this.$translate('EXPORT_TO_EMAIL_CONFIRM_IOS_PART_1', { username: username }) + '</span>\n                  <a ng-click="$root.openIOSTerm($event)" data-tap-disabled=\'true\'>' + this.$translate('TERMS_AND_CONDITIONS_SMALL_CASE') + '</a>\n                  <span>' + this.$translate('EXPORT_TO_EMAIL_CONFIRM_IOS_PART_2') + '</span>' : this.$translate('EXPORT_TO_EMAIL_CONFIRM', { username: username })
            });

            confirmPopup.then(function (res) {
                if (res) {
                    sentEmail();
                }
            }.bind(this));
        }
    }]);

    return SentEmailPopup;
}();

exports.default = SentEmailPopup;


/** WEBPACK FOOTER **
 ** ./src/app/services/sentEmailPopup.js
 **/